import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function SuccessView({ onClose }: { onClose: () => void }): ReactNode {
	const { t } = useTranslation();

	return (
		<div className="ea-success">
			<div className="ea-success-icon">
				<svg
					width="48"
					height="48"
					viewBox="0 0 48 48"
					fill="none"
					stroke="var(--green)"
					strokeWidth="2"
				>
					<circle cx="24" cy="24" r="22" opacity="0.2" />
					<path d="M14 24l7 7 13-13" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</div>
			<h3>{t("cta.successTitle")}</h3>
			<p>{t("cta.successMessage")}</p>
			<button className="btn btn-ghost" type="button" onClick={onClose}>
				{t("cta.close")} <span className="arrow">&rarr;</span>
			</button>
		</div>
	);
}
